<script>
import pdfvuer from 'pdfvuer'

export default {
  components: {
    pdf: pdfvuer,
  },
  props: {
    src: {
      default: undefined,
      type: String,
    },
  },
  data() {
    return {
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: false,
      loaded: false,
      scale: 'page-width',
    }
  },
  computed: {
    formattedZoom() {
      return Number.parseInt(this.scale * 100)
    },
  },
  watch: {
    show: function(s) {
      if (s) {
        this.getPdf()
      }
    },
    page: function(p) {
      var pdfViewer = this.$refs.pdfViewerRef
      if (
        pdfViewer.scrollTop <= this.findPos(document.getElementById(p)) ||
        (document.getElementById(p + 1) &&
          pdfViewer.scrollTop >= this.findPos(document.getElementById(p + 1)))
      ) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView()
      }
    },
  },
  mounted() {
    this.getPdf()
    console.log(this.src)
  },
  methods: {
    getPdf() {
      var self = this
      self.pdfdata = pdfvuer.createLoadingTask(self.src)
      var pdfViewer = this.$refs.pdfViewerRef
      self.pdfdata
        .then((pdf) => {
          self.numPages = pdf.numPages
          this.loaded = true
          pdfViewer.onscroll = function() {
            changePage()
          }
          function changePage() {
            var i = 1
            var count = Number(pdf.numPages)
            do {
              if (
                pdfViewer.scrollTop >=
                  self.findPos(document.getElementById(i)) &&
                pdfViewer.scrollTop <=
                  self.findPos(document.getElementById(i + 1))
              ) {
                self.page = i
              }
              i++
            } while (i < count)
            if (
              pdfViewer.scrollTop >= self.findPos(document.getElementById(i))
            ) {
              self.page = i
            }
          }
        })
        .catch((e) => {
          if (e) {
            this.errors = true
          }
        })
    },
    findPos(obj) {
      if (obj !== null) return obj.offsetTop
    },
    reloadIframe() {
      document.getElementsByTagName(
        'object'
      )[0].data = document.getElementsByTagName('object')[0].data
    },
  },
}
</script>

<template>
  <div>
    <div v-if="errors">
      <b-alert dismissible show variant="warning">
        <span pointer @click="reloadIframe">{{
          $t('Click here rapidly if you see a blank page')
        }}</span>
      </b-alert>
      <object
        :data="
          'https://drive.google.com/viewerng/viewer?embedded=true&url=' + src
        "
        type="application/pdf"
        width="100%"
        height="1000px"
      >
        <embed
          :src="
            'https://drive.google.com/viewerng/viewer?embedded=true&url=' + src
          "
          type="application/pdf"
        />
      </object>
    </div>
    <div v-else class="position-relative">
      <div v-show="numPages" id="pdfViewer" ref="pdfViewerRef">
        <div>
          <pdf
            v-for="i in numPages"
            :id="i"
            :key="i"
            :src="pdfdata"
            :page="i"
            :scale.sync="scale"
            style="width:100%;margin:20px auto;"
          >
            <template slot="loading">
              loading content here...
            </template>
          </pdf>
        </div>
      </div>
      <div v-show="numPages" class="menuActions">
        <div id="buttons">
          <a class="item" pointer @click="page > 1 ? page-- : 1">
            <img src="@assets/icons/chevron.svg" alt="chevron" width="20px" />
          </a>
          <a class="ui active item" pointer>
            {{ page }} / {{ numPages ? numPages : '∞' }}
          </a>
          <a class="item" pointer @click="page < numPages ? page++ : 1">
            <img
              src="@assets/icons/chevron.svg"
              alt="chevron"
              width="20px"
              style="transform: rotate(180deg)"
            />
          </a>
        </div>
      </div>
      <div v-show="!numPages" style="min-height:10rem">
        <img
          src="@assets/icons/loading.gif"
          alt="loading"
          class="loadingIcon"
        />
      </div>

      <div v-show="numPages" class="mobileActions d-lg-none d-sm-block">
        <div id="buttons">
          <a
            class="item"
            :style="{ fontSize: '.9rem' }"
            pointer
            @click="scale -= scale > 0.2 ? 0.1 : 0"
          >
            Zoom -
          </a>
          <a class="ui active item" pointer> {{ formattedZoom }} % </a>
          <a
            class="item"
            :style="{ fontSize: '.9rem' }"
            pointer
            @click="scale += scale < 2 ? 0.1 : 0"
          >
            Zoom +
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#buttons {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

/* Page content */
.content {
  padding: 16px;
}
#pdfViewer {
  position: relative;
  max-height: 95vh;
  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  &::-webkit-scrollbar-track {
    background: #f7f7f7;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--primary);
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}
.menuActions {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  #buttons {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
}

@media only screen and (max-width: 600px) {
  #pdfViewer {
    overflow-x: auto !important;
    &::-webkit-scrollbar {
      height: 5px;
    }
  }
  .menuActions {
    left: -0.5rem;
  }
  .mobileActions {
    position: absolute;
    bottom: 4px;
    width: calc(100% - 5px);
    background: #fff;
    #buttons {
      display: flex;
      justify-content: space-around;
      padding: 0.25rem 0;
    }
  }
}
</style>
